import React from "react";
import { Icon } from "../";

/**
 * Banner component to inform users about POS integration restrictions
 * Displays when a business has an active POS integration
 */
const POSIntegrationBanner = () => {
  return (
    <div className="rounded-lg border border-blue-500/30 bg-gradient-to-r from-blue-900/30 via-purple-900/30 to-blue-900/30 p-3 shadow-lg backdrop-blur-sm sm:p-4">
      <div className="flex items-center gap-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg border border-blue-500/30 bg-blue-500/20 sm:h-10 sm:w-10">
            <Icon name="Info" className="h-4 w-4 text-blue-400 sm:h-5 sm:w-5" />
          </div>
        </div>

        {/* Content */}
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-3">
            <h3 className="text-sm font-semibold text-white sm:text-base">
              POS Integration Active
            </h3>
            <div className="flex items-center gap-4 text-xs text-gray-300 sm:text-sm">
              <div className="flex items-center gap-1.5">
                <Icon
                  name="CheckCircle"
                  className="h-3.5 w-3.5 flex-shrink-0 text-blue-400"
                />
                <span>Activate/deactivate products</span>
              </div>
              <div className="flex items-center gap-1.5">
                <Icon
                  name="XCircle"
                  className="h-3.5 w-3.5 flex-shrink-0 text-gray-500"
                />
                <span>No create/edit/delete</span>
              </div>
            </div>
          </div>
          <p className="mt-2 text-xs text-blue-200/80">
            Changes must be made in your POS system or disconnect the
            integration first.
          </p>
        </div>
      </div>
    </div>
  );
};

export default POSIntegrationBanner;
